import EditorJS from '@editorjs/editorjs';
const Header = require('@editorjs/header');
const Attach = require('./attaches.js');
import LinkCard from './linkcard.js';
import Delimiter from './delimiter';
// eslint-disable-next-line
import polyfill from 'url-polyfill';

const editor = new EditorJS({
    holder: 'editorjs',
    readOnly: true,
    minHeight : 20,
    tools: {
        header: Header,
        attach: Attach,
        link: LinkCard,
        delimiter: Delimiter
    },
    data: window.savedData || {}
});
window.renderer = editor;